import { Spinner } from '@/components/Spinner';
import { ManageDiscountForm } from './ManageDiscountForm';
import { useGetDiscountCategoryDetail } from './hooks/useGetDiscountCategoryDetail';

export interface ManageDiscountFormDefaultValues {
  category: string;
  description: string;
}

const ManageDiscountFormContainer = ({
  defaultValues,
  categoryId,
}: {
  defaultValues?: ManageDiscountFormDefaultValues;
  categoryId?: string;
}) => {
  const { detail, isLoading } = useGetDiscountCategoryDetail(categoryId);

  const formDefaultValues = {
    category: defaultValues?.category ?? detail?.categoryName ?? '',
    description: defaultValues?.description ?? detail?.categoryDescription ?? '',
  };

  if (categoryId && isLoading) {
    return <Spinner />;
  }

  return <ManageDiscountForm defaultValues={formDefaultValues} categoryId={categoryId} />;
};

export default ManageDiscountFormContainer;
